import React, { useState, useEffect } from 'react'
import { Panel, Table, IconButton, Icon, Form, Button } from 'rsuite'
import { isEmpty, findIndex } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'
import ConfirmWidget from '../confirm/ConfirmWidget'
import EditNumberCell from './cell/EditNumberCell'
import EditTextCell from './cell/EditTextCell'
import './styles.less'
import classNames from 'classnames'

const { Column, HeaderCell, Cell } = Table

export default function WithdrawalEditTable({ data, readOnly, register, errors, control, onChangeTotal = () =>{} }) {
  //const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    if (isEmpty(data)) {
      setTableData()
      return
    }
    if (!readOnly) {
      setIsEdit(true)
    } else {
      setIsEdit(false)
    }

    const totalData = {
      id: uuidv4(),
      list: 'รวมจำนวนเงิน',
      cost: 0,
      isTotal: true,
    }
    setTableData([...data, totalData])
  }, [data, readOnly])

  const handleOnConfirmDelete = () => {
    setIsShowConfirmDelete(false)
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.cost && !cur.isTotal) {
        return pre + cur.cost
      }
      return pre
    }, 0)
  }

  const handleOnChangeValue = (value, id) => {
    var _tableData = tableData
    var newData = _tableData.map((item)=> {
      if(item.id === id){
        item.cost = value || 0
      }
      return item
    })
    setTableData(newData)

    var total = getTotalSummary(newData)
    onChangeTotal(total)
  }

  return (
    <div className="period-expenses">
      <Panel>
        {tableData && (
          <Form className="form-table">
            <Table
              rowKey="id"
              autoHeight
              data={tableData}
              shouldUpdateScroll={false}
              rowHeight={(rowData) => (rowData?.isDetail ? 210 : 80)}
              wordWrap
            >
              <Column flexGrow={1}>
                <HeaderCell>ผู้ทรงคุณวุฒิ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    // if (rowData.isTotal) {
                    //   return (
                    //     <span className={classNames(rowData.isTotal && 'total-summary')}>
                    //       {rowData.list}
                    //     </span>
                    //   )
                    // }
                    return <span>{rowData.reviewerName}</span>
                  }}
                </Cell>
              </Column>

              

              <Column width={150} flexGrow={1}>
                <HeaderCell>ธนาคาร</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData.isTotal) {
                      return (
                        <EditTextCell
                          rowData={rowData}
                          dataKey="bankName"
                          register={register}
                          control={control}
                          isEdit={false}
                          errors={errors}
                          required={!rowData.cost && { required : false}}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              <Column width={150} flexGrow={1}>
                <HeaderCell>สาขา</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData.isTotal) {
                      return (
                        <EditTextCell
                          rowData={rowData}
                          dataKey="bankBranch"
                          register={register}
                          control={control}
                          isEdit={false}
                          errors={errors}
                          required={!rowData.cost && { required : false}}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              <Column width={150} colSpan={2} flexGrow={1}>
                <HeaderCell>เลขที่บัญชี</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData.isTotal) {
                      return (
                        <EditTextCell
                          rowData={rowData}
                          dataKey="bankAccountNumber"
                          register={register}
                          control={control}
                          isEdit={false}
                          errors={errors}
                          required={!rowData.cost && { required : false}}
                        />
                      )
                    }
                    if (rowData.isTotal) {
                      return (
                        <span className={classNames(rowData.isTotal && 'total-summary')}>
                          {rowData.list}
                        </span>
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              <Column width={150} align="right">
                <HeaderCell style={{paddingRight: 30}}>จำนวนเงิน (บาท)</HeaderCell>
                <Cell style={{paddingRight: 30}}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <span className={'cost-total-summary'} >
                          {`${getTotalSummary(tableData).toLocaleString()}`}
                        </span>
                      )
                    } else {
                      return (
                        <EditNumberCell
                          rowData={rowData}
                          dataKey="cost"
                          register={register}
                          control={control}
                          errors={errors}
                          isEdit={isEdit}
                          onChangeValue={handleOnChangeValue}
                          required={{ required : false}}
                          disabled={!rowData.bankAccountNumber}
                        />
                      )
                    }
                  }}
                </Cell>
              </Column>
            </Table>
          </Form>
        )}
      </Panel>
      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />
    </div>
  )
}
